import { useQuery } from "@tanstack/react-query";

import { useApiHeaders } from "@/hooks/use-api-headers";
import { useAdminOrgStore } from "@/stores/admin-org";
import { useTranslation } from "@/i18n/use-translation";
import { apiError } from "@/lib/api-error";

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:8000";

export type Device = {
  id: string;
  kitchen_id: string;
  device_serial: string;
  name: string | null;
  status: "active" | "inactive" | "maintenance";
  location: "prep_area" | "service_line" | "wash_up" | "cold_store" | null;
};

export function useDevices() {
  const { t } = useTranslation();
  const headers = useApiHeaders();
  const orgId = useAdminOrgStore((s) => s.orgId);
  return useQuery<Device[]>({
    queryKey: ["devices", orgId],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/api/v1/devices`, { headers });
      if (!res.ok) throw await apiError(t, res);
      const body = (await res.json()) as { data: Device[] };
      return body.data;
    },
    enabled: !!headers.Authorization.replace("Bearer ", ""),
    staleTime: 5 * 60_000,
  });
}
